module.exports = __webpack_public_path__ + "static/img/score-ten.7d75cd6c.jpg";